import React from "react";
import sessionsDestroy from "storefront/GrailedAPI/v1/Sessions/destroy";

export const signOut = (evt: React.SyntheticEvent<HTMLElement>) => {
  evt.preventDefault();
  sessionsDestroy().then(() => {
    window.location.href = "/";
  });
};
